import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useHistory, useLocation } from "react-router";

import { PasswordSetting_initialize, PasswordSettingSet, PasswordSettingMail } from "../../stores/slices/PasswordSetting";

const PasswordSetting = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const informationState = useSelector((state) => state.Information);
    const PasswordSettingState = useSelector((state) => state.PasswordSetting);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        //ログイン済みならトップページへ
        if(informationState["organizer"]["user_login"] === true)
        {
            history.push(`/`);
            return;
        }
    }, [informationState]);

    //送信ボタン
    const HandleSubmit = (e) => {
        setDisabled(true);
        e.preventDefault();

        //メール送信
        dispatch(PasswordSettingMail(PasswordSettingState)).then((data) => {
            const result = data.payload.result;
            console.log(result);
            if(result === 'OK')
            {
                //メール送信後、画面表示を切り替える
                dispatch(PasswordSettingSet(['send', true]));
            }
            else
            {
                //NGメッセージ表示
                alert(data.payload.message);
                setDisabled(false);
            }
        });
    };

    //値変更
    const onChange = (params) => {
        const { name, value } = params;
        dispatch(PasswordSettingSet([name, value]));
    };

    //戻る
    const LinkClick = () => {
        history.push(`/Login`);
    };

    return (
        <React.Fragment>
            <Typography variant="h2" align="center">
                パスワード再設定
            </Typography>
            <Button size="small" variant="outlined" onClick={LinkClick}>
                戻る
            </Button>
            <form onSubmit={HandleSubmit} style={{ display: PasswordSettingState.send ? 'none' : '' }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ minHeight: "300px" }}
                >
                    {"アカウントに登録しているメールアドレスを入力してください。"}
                    <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
                        <TextField
                            required
                            sx={{ maxWidth: "20rem", m: 1, fontSize: "1.2rem" }}
                            label="メールアドレス"
                            variant="outlined"
                            name="email_address"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 60 }}
                            value={PasswordSettingState.email_address}
                            onChange={(e) => onChange({ name: "email_address", value: e.target.value })}
                            type="email"
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
                    <Button variant="contained" type="submit" fullWidth sx={{ maxWidth: "10rem" }} disabled={disabled}>
                        送信
                    </Button>
                </Grid>
            </form>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ minHeight: "300px" }}
                style={{ display: PasswordSettingState.send ? '' : 'none' }}
            >
                <Typography variant="h5" gutterBottom component="div" sx={{ mt: 3 }}>
                    {PasswordSettingState.email_address}
                </Typography>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    sx={{ minHeight: "100px", maxWidth: "350px" }}
                >
                    {"上記のメールアドレス宛に、パスワード再設定用のURLをお送りいたしました。メールをご確認し再設定の手続きを行ってください。"}
                </Grid>
                <a style={{ color: "red", textAlign: 'center' }} >
                    {"※ご注意"}
                </a>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    sx={{ minHeight: "50px", maxWidth: "350px" }}
                >
                    <a style={{ color: "red"}} >
                        {"パスワードの再設定の有効期限は30分です。30分以内に登録を行ってください。"}
                    </a>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default PasswordSetting;
